module.exports = __webpack_public_path__ + "img/img_faguang_left.d82d03dd.png";